import "./styloParallax.css";

import { BsWhatsapp, BsInstagram } from "react-icons/bs";
import { MdNextPlan } from "react-icons/md";
import { LuPhoneCall } from "react-icons/lu";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import { GiCube } from "react-icons/gi";
import SlideShow from "./component/slideShow";
import CentralAssinante from "./component/centralAssinante";
// Exemplo de importação em um componente React
import "@fontsource/roboto";
import Header from "./component/header";
import AreaAjuda from "./component/areaAjuda";
import Rodape from "./component/footer";
import AreaPlanos from "./component/areaplanos";
import AreaSobre from "./component/sobre";
import Copy from "./component/copyri";

export default function Home() {
  return (
    <div className="container-pg">
     
        <Header />
        <SlideShow />
        <AreaAjuda/>

    <section class="parallax parallax-1">
        <div class="parallax-text">
            <h2>Confira Nossos Planos</h2>
            <p>Oferecemos soluções incríveis para você</p>
        </div>
    </section>
      
      <AreaPlanos/>

      <section class="parallax parallax-2">
        <div class="parallax-text">
            <h2>Junte-se a Nós</h2>
            <p>Vamos criar algo extraordinário juntos</p>
        </div>
    </section>

      <AreaSobre />
      <Rodape/>
      <Copy/>
    </div>
  );
}
